import { useQuery } from '@tanstack/react-query';

import { Space } from 'src/features/spaces/utils/types';
import axios from 'src/lib/axios';
import { ListResponseSmartParkAPI } from 'src/lib/queries';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/sites/space/`;

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    parkingId: string;
}

const queryFn = ({ parkingId, ...params }: DTO): Promise<ListResponseSmartParkAPI<Space>> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_SPACES_RESOURCE, useQueryHook as useListSpaces };
